var url = window.location.href;  

if(url == "https://green-ethnies.ch/pages/quels-sont-les-complements-alimentaires-dont-j-ai-besoin#begin")
{
  $("#contentCustomPageAACSection0").css("display", "none");
  document.getElementById("loader-container").classList.add("active");
  document.getElementById("load").classList.add("active");
  setTimeout(function(){
    document.getElementById("loader-container").classList.remove("active");
    document.getElementById("load").classList.remove("active");
  }, 2500);
  $("#contentCustomPageAACSection1").css("display", "block");
}

/* ONCLICK BUTTON FORM NEXT 1 */
function checkbeginform() {  
  var checkBox = document.getElementById("checkbeginform");
  var text = document.getElementById("continueForm");
  if (checkBox.checked == true){
	text.disabled = false;
	$(".btnbegin .tooltiptext").hide();
  } else {
	text.disabled = true;
	$(".btnbegin .tooltiptext").show();
  }
}
/* ONCLICK BUTTON FORM NEXT 0 */

/* ONCLICK BUTTON FORM NEXT 1 */
function nextForm1() {
  $('#contentCustomPageAACSection1 input[type="checkbox"].checkboxform1step1').on('change', function() {
	
	$('#contentCustomPageAACSection1 input[type="checkbox"].checkboxform1step1').not(this).prop('checked', false);
	
	var fields1 = '';
	$('#contentCustomPageAACSection1 input[type="checkbox"].checkboxform1step1').each(function() {
	  if (this.checked) {
		fields1 += $(this).val() + ' ';
	  }
	});
	$('.step1resultstest #field_results1step1').val($.trim(fields1))
  });
  
  $('#contentCustomPageAACSection1 input[type="checkbox"].checkboxform2step1').on('change', function() {
	
	$('#contentCustomPageAACSection1 input[type="checkbox"].checkboxform2step1').not(this).prop('checked', false);
	
	var fields2 = '';
	$('#contentCustomPageAACSection1 input[type="checkbox"].checkboxform2step1').each(function() {
	  if (this.checked) {
		fields2 += $(this).val() + ' ';
	  }
	});
	$('.step1resultstest #field_results2step1').val($.trim(fields2))
  });
  
  var checkBox = document.getElementById("checkboxform1step1");
  var checkBoxx = document.getElementById("checkboxform2step1");
  var checkSelect = document.getElementById("selectform3step1");
  var selectedValue = checkSelect.options[checkSelect.selectedIndex].value;
  var text = document.getElementById("nextForm1");
  if (($('#checkboxform1step1:checked').length) && ($('#checkboxform2step1:checked').length) && (checkSelect.selectedIndex > 0)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}

document.getElementById('selectform3step1').addEventListener('change', function() {
  var fields3 = '';
  $('#contentCustomPageAACSection1 select.selectform3step1').each(function() {
	if (this.tagName === 'SELECT') {
	  fields3 += $(this).val() + ' ';
	}
  });
  $('.step1resultstest #field_results3step1').val($.trim(fields3));
  var checkBox = document.getElementById("checkboxform1step1");
  var checkBoxx = document.getElementById("checkboxform2step1");
  var checkSelect = document.getElementById("selectform3step1");
  var selectedValue = checkSelect.options[checkSelect.selectedIndex].value;
  var text = document.getElementById("nextForm1");
  if (($('#checkboxform1step1:checked').length) && ($('#checkboxform2step1:checked').length) && (checkSelect.selectedIndex > 0)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}, false);
/* ONCLICK BUTTON FORM NEXT 1 */

/* ONCLICK BUTTON FORM NEXT 2 */
function nextForm2() {
  $('#contentCustomPageAACSection2 input[type="checkbox"].checkboxform1step2').on('change', function() {

	$('#contentCustomPageAACSection2 input[type="checkbox"].checkboxform1step2').on('change', function() {
	  $('#contentCustomPageAACSection2 input[type="checkbox"].checkboxform1step2').not(this).prop('checked', false);
	});
	
	var fields1 = '';
	$('#contentCustomPageAACSection2 input[type="checkbox"].checkboxform1step2').each(function() {
	  if (this.checked) {
		fields1 += $(this).val() + ' ';
	  }
	});
	$('.step2resultstest #field_results1step2').val($.trim(fields1));

	if($('.step2resultstest #field_results1step2').val() === "D") {
	  $('.infoutileformstep2').addClass("active");
	} else {
	  $('.infoutileformstep2').removeClass("active");
	}
  });
  
  $('#contentCustomPageAACSection2 input[type="checkbox"].checkboxform2step2').on('change', function() {

	$('#contentCustomPageAACSection2 input[type="checkbox"].checkboxform2step2').on('change', function() {
	  $('#contentCustomPageAACSection2 input[type="checkbox"].checkboxform2step2').not(this).prop('checked', false);
	});
	
	var fields2 = '';
	$('#contentCustomPageAACSection2 input[type="checkbox"].checkboxform2step2').each(function() {
	  if (this.checked) {
		fields2 += $(this).val() + ' ';
	  }
	});
	$('.step2resultstest #field_results2step2').val($.trim(fields2))
  });
  
  var checkBox = document.getElementById("checkboxform1step2");
  var checkBoxx = document.getElementById("checkboxform2step2");
  var text = document.getElementById("nextForm2");
  if (($('#checkboxform1step2:checked').length) && ($('#checkboxform2step2:checked').length)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}
/* ONCLICK BUTTON FORM NEXT 2 */

/* ONCLICK BUTTON FORM NEXT 3 */
function nextForm3() {
  $('#contentCustomPageAACSection3 input[type="checkbox"].checkboxform1step3').on('change', function() {

	$('#contentCustomPageAACSection3 input[type="checkbox"].checkboxform1step3').on('change', function() {
	  $('#contentCustomPageAACSection3 input[type="checkbox"].checkboxform1step3').not(this).prop('checked', false);
	});
	
	var fields1 = '';
	$('#contentCustomPageAACSection3 input[type="checkbox"].checkboxform1step3').each(function() {
	  if (this.checked) {
		fields1 += $(this).val() + ' ';
	  }
	});
	$('.step3resultstest #field_results1step3').val($.trim(fields1));
	if($('.step3resultstest #field_results1step3').val() === "D") {
	  $('.infoutileformstep3').addClass("active");
	} else {
	  $('.infoutileformstep3').removeClass("active");
	}
  });
  
  $('#contentCustomPageAACSection3 input[type="checkbox"].checkboxform2step3').on('change', function() {

	$('#contentCustomPageAACSection3 input[type="checkbox"].checkboxform2step3').on('change', function() {
	  $('#contentCustomPageAACSection3 input[type="checkbox"].checkboxform2step3').not(this).prop('checked', false);
	});
	
	var fields2 = '';
	$('#contentCustomPageAACSection3 input[type="checkbox"].checkboxform2step3').each(function() {
	  if (this.checked) {
		fields2 += $(this).val() + ' ';
	  }
	});
	$('.step3resultstest #field_results2step3').val($.trim(fields2));
	if($('.step3resultstest #field_results2step3').val() === "C") {
	  $('.infoutileformstep4').addClass("active");
	} else {
	  $('.infoutileformstep4').removeClass("active");
	}
  });
  
  var checkBox = document.getElementById("checkboxform1step3");
  var checkBoxx = document.getElementById("checkboxform2step3");
  var text = document.getElementById("nextForm3");
  if (($('#checkboxform1step3:checked').length) && ($('#checkboxform2step3:checked').length)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}
/* ONCLICK BUTTON FORM NEXT 3 */

/* ONCLICK BUTTON FORM NEXT 4 */
function nextForm4() {    
  $('#contentCustomPageAACSection4 input[type="checkbox"].checkboxform3step4').on('change', function() {

	$('#contentCustomPageAACSection4 input[type="checkbox"].checkboxform3step4').not(this).prop('checked', false);
	
	var fields3 = '';
	$('#contentCustomPageAACSection4 input[type="checkbox"].checkboxform3step4').each(function() {
	  if (this.checked) {
		fields3 += $(this).val() + ' ';
	  }
	});
	$('.step4resultstest #field_results3step4').val($.trim(fields3))
  });
  
  var checkSelect = document.getElementById("selectform1step4");
  var selectedValue = checkSelect.options[checkSelect.selectedIndex].value;
  var checkSelectt = document.getElementById("selectform2step4");
  var selectedValuee = checkSelectt.options[checkSelectt.selectedIndex].value;
  var checkBox = document.getElementById("checkboxform3step4");
  var text = document.getElementById("nextForm4");
  if (($('#checkboxform3step4:checked').length) && (checkSelect.selectedIndex > 0) && (checkSelectt.selectedIndex > 0)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}

document.getElementById('selectform1step4').addEventListener('change', function() {
  var fields1 = '';
  $('#contentCustomPageAACSection4 select.selectform1step4').each(function() {
	if (this.tagName === 'SELECT') {
	  fields1 += $(this).val() + ' ';
	}
  });
  $('.step4resultstest #field_results1step4').val($.trim(fields1));
  
  var checkSelect = document.getElementById("selectform1step4");
  var selectedValue = checkSelect.options[checkSelect.selectedIndex].value;
  var checkSelectt = document.getElementById("selectform2step4");
  var selectedValuee = checkSelectt.options[checkSelectt.selectedIndex].value;
  var checkBox = document.getElementById("checkboxform3step4");
  var text = document.getElementById("nextForm4");
  if (($('#checkboxform3step4:checked').length) && (checkSelect.selectedIndex > 0) && (checkSelectt.selectedIndex > 0)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}, false);
document.getElementById('selectform2step4').addEventListener('change', function() {
  var fields2 = '';
  $('#contentCustomPageAACSection4 select.selectform2step4').each(function() {
	if (this.tagName === 'SELECT') {
	  fields2 += $(this).val() + ' ';
	}
  });
  $('.step4resultstest #field_results2step4').val($.trim(fields2));
  var checkSelect = document.getElementById("selectform1step4");
  var selectedValue = checkSelect.options[checkSelect.selectedIndex].value;
  var checkSelectt = document.getElementById("selectform2step4");
  var selectedValuee = checkSelectt.options[checkSelectt.selectedIndex].value;
  var checkBox = document.getElementById("checkboxform3step4");
  var text = document.getElementById("nextForm4");
  if (($('#checkboxform3step4:checked').length) && (checkSelect.selectedIndex > 0) && (checkSelectt.selectedIndex > 0)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}, false);
/* ONCLICK BUTTON FORM NEXT 4 */

/* ONCLICK BUTTON FORM NEXT 5 */
$(document).ready(function() {
  $("input#checkboxform1step5.value2").click(function() {
	if($(this).prop("checked") == true) {
	  $(".form2showstep5").addClass("active");
	  $(".form3showstep5").addClass("active");
	}
	else if($(this).prop("checked") == false) {
	  $(".form2showstep5").removeClass("active");
	  $(".form3showstep5").removeClass("active");
	}
  });
});

$(document).ready(function() {
  $("input#checkboxform1step5.value1").click(function() {
	if($(this).prop("checked") == true) {
	  $(".form2showstep5").removeClass("active");
	  $(".form3showstep5").removeClass("active");
	  $('.step5resultstest #field_results1step5').val($.trim("0"));
	  $('.step5resultstest #field_results2step5').val($.trim("0"));
	  $('.step5resultstest #field_results3step5').val($.trim("0"));
	  var selectform2step5 = document.querySelector('#selectform2step5');
	  selectform2step5.value = '';
	  var selectform3step5 = document.querySelector('#selectform3step5');
	  selectform3step5.value = '';
	  var text = document.getElementById("nextForm5");
	  text.disabled = false;
	}
  });
});
function nextForm5() {
  $('#contentCustomPageAACSection5 input[type="checkbox"].checkboxform1step5').on('change', function() {

	$('#contentCustomPageAACSection5 input[type="checkbox"].checkboxform1step5').not(this).prop('checked', false);
	
	var fields1 = '';
	$('#contentCustomPageAACSection5 input[type="checkbox"].checkboxform1step5').each(function() {
	  if (this.checked) {
		fields1 += $(this).val() + ' ';
	  }
	});
	$('.step5resultstest #field_results1step5').val($.trim(fields1))
  });
  
  var checkBox = document.getElementById("checkboxform1step5");
  var checkSelect = document.getElementById("selectform2step5");
  var selectedValue = checkSelect.options[checkSelect.selectedIndex].value;
  var checkSelectt = document.getElementById("selectform3step5");
  var selectedValuee = checkSelectt.options[checkSelectt.selectedIndex].value;
  var text = document.getElementById("nextForm5");
  if (($('#inputstylecheckboxC:last-child #checkboxform1step5:checked').length) && (checkSelect.selectedIndex > 0) && (checkSelectt.selectedIndex > 0)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}

document.getElementById('selectform2step5').addEventListener('change', function() {
  var fields2 = '';
  $('#contentCustomPageAACSection5 select.selectform2step5').each(function() {
	if (this.tagName === 'SELECT') {
	  fields2 += $(this).val() + ' ';
	}
  });
  $('.step5resultstest #field_results2step5').val($.trim(fields2));
  var checkBox = document.getElementById("checkboxform1step5");
  var checkSelect = document.getElementById("selectform2step5");
  var selectedValue = checkSelect.options[checkSelect.selectedIndex].value;
  var checkSelectt = document.getElementById("selectform3step5");
  var selectedValuee = checkSelectt.options[checkSelectt.selectedIndex].value;
  var text = document.getElementById("nextForm5");
  if (($('#inputstylecheckboxC:last-child #checkboxform1step5:checked').length) && (checkSelect.selectedIndex > 0) && (checkSelectt.selectedIndex > 0)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}, false);
document.getElementById('selectform3step5').addEventListener('change', function() {
  var fields3 = '';
  $('#contentCustomPageAACSection5 select.selectform3step5').each(function() {
	if (this.tagName === 'SELECT') {
	  fields3 += $(this).val() + ' ';
	}
  });
  $('.step5resultstest #field_results3step5').val($.trim(fields3));
  var checkBox = document.getElementById("checkboxform1step5");
  var checkSelect = document.getElementById("selectform2step5");
  var selectedValue = checkSelect.options[checkSelect.selectedIndex].value;
  var checkSelectt = document.getElementById("selectform3step5");
  var selectedValuee = checkSelectt.options[checkSelectt.selectedIndex].value;
  var text = document.getElementById("nextForm5");
  if (($('#inputstylecheckboxC:last-child #checkboxform1step5:checked').length) && (checkSelect.selectedIndex > 0) && (checkSelectt.selectedIndex > 0)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}, false);
/* ONCLICK BUTTON FORM NEXT 5 */

/* ONCLICK BUTTON FORM NEXT 6 */
$('#contentCustomPageAACSection6 input[type="checkbox"].checkboxform1step6').on('click', function() {

  var checkBox = document.getElementById("checkboxform1step6");
  var checkBoxx = document.getElementById("checkboxform2step6");
  var text = document.getElementById("nextForm6");
  if (($('#inputstylecheckboxC #checkboxform1step6:checked').length) && ($('#inputstylecheckboxC #checkboxform2step6:checked').length)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
	
});

$('#contentCustomPageAACSection6 input[type="checkbox"].checkboxform2step6').on('click', function() {

  var checkBox = document.getElementById("checkboxform1step6");
  var checkBoxx = document.getElementById("checkboxform2step6");
  var text = document.getElementById("nextForm6");
  if (($('#inputstylecheckboxC #checkboxform1step6:checked').length) && ($('#inputstylecheckboxC #checkboxform2step6:checked').length)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
	
});


$('#contentCustomPageAACSection6 .inputstylecheckboxlast input[type="checkbox"].checkboxform2step6').on('click', function() {

  if ($(this).is(":checked") ) {
		$("#textareaform2step6").addClass("active");
	} 
	else  
	{
		$("#textareaform2step6").removeClass("active");
	}
	
});


/* ONCLICK BUTTON FORM NEXT 6 */

/* ONCLICK BUTTON FORM NEXT 7 */
$(document).ready(function() {
  $("input#checkboxform1step7.value2").click(function() {
	if($(this).prop("checked") == true) {
	  $(".form2showstep7").addClass("active");
	}
	else if($(this).prop("checked") == false) {
	  $(".form2showstep7").removeClass("active");
	}
  });
});

$(document).ready(function() {
  $("input#checkboxform1step7.value1").click(function() {
	if($(this).prop("checked") == true) {
	  $(".form2showstep7").removeClass("active");
	  $('.step7resultstest #field_results1step7').val($.trim("0"));
	  $('.step7resultstest #field_results2step7').val($.trim("0"));
	  var selectform2step7 = document.querySelector('#selectform2step7');
	  selectform2step7.value = '';
	  var text = document.getElementById("nextForm7");
	  text.disabled = false;
	}
  });
});

function nextForm7() {
  $('#contentCustomPageAACSection7 input[type="checkbox"].checkboxform1step7').on('click', function() {

	$('#contentCustomPageAACSection7 input[type="checkbox"].checkboxform1step7').not(this).prop('checked', false);
	
	var fields1 = '';
	$('#contentCustomPageAACSection7 input[type="checkbox"].checkboxform1step7').each(function() {
	  if (this.checked) {
		fields1 += $(this).val() + ' ';
	  }
	});
	$('.step7resultstest #field_results1step7').val($.trim(fields1))
  });
  
  var checkBox = document.getElementById("checkboxform1step7");
  var checkSelect = document.getElementById("selectform2step7");
  var selectedValue = checkSelect.options[checkSelect.selectedIndex].value;
  var text = document.getElementById("nextForm7");
  if (($('#inputstylecheckboxC:last-child #checkboxform1step7:checked').length) && (checkSelect.selectedIndex > 0)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}

document.getElementById('selectform2step7').addEventListener('change', function() {
  var fields2 = '';
  $('#contentCustomPageAACSection7 select.selectform2step7').each(function() {
	if (this.tagName === 'SELECT') {
	  fields2 += $(this).val() + ' ';
	}
  });
  $('.step7resultstest #field_results2step7').val($.trim(fields2));
  var checkBox = document.getElementById("checkboxform1step7");
  var checkSelect = document.getElementById("selectform2step7");
  var selectedValue = checkSelect.options[checkSelect.selectedIndex].value;
  var text = document.getElementById("nextForm7");
  if (($('#inputstylecheckboxC:last-child #checkboxform1step7:checked').length) && (checkSelect.selectedIndex > 0)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}, false);
/* ONCLICK BUTTON FORM NEXT 7 */

/* ONCLICK BUTTON FORM NEXT 7 (option no) */
function nextForm7No() {
  var checkBox = document.getElementById("checkboxform1step7");
  var checkSelect = document.getElementById("selectform2step7");
  var selectedValue = checkSelect.options[checkSelect.selectedIndex].value;
  var text = document.getElementById("nextForm7");
  if (($('#inputstylecheckboxC:first-child #checkboxform1step7:checked').length)) {
	text.disabled = false;
  }
}
/* ONCLICK BUTTON FORM NEXT 7 (option no) */

/* ONCLICK BUTTON FORM NEXT 8 */
$("input[name='test']").change(function () {
  var maxAllowed = 3;
  var cnt = $("input[name='test']:checked").length;
  var text = document.getElementById("nextForm8");
  var errorCheckM = document.getElementById("errormessageM");
  if (cnt > maxAllowed) 
  {
	$(this).prop("checked", "");
	//text.disabled = true;
	errorCheckM.classList.add("active");
  } 
  else if (cnt < maxAllowed)
  {
	text.disabled = true;
	errorCheckM.classList.remove("active");
  }
  else
  {
	text.disabled = false;
	errorCheckM.classList.remove("active");
  }
});
function nextForm8() {
  var checkboxes = document.getElementsByName('test');
  var result = "";
  
  for (var i = 0; i < checkboxes.length; i++) {
    if (checkboxes[i].checked) {
	  result += checkboxes[i].value;
    }
  }
  $('.step8resultstest #field_results1step8separ1').val(result[0]);
  $('.step8resultstest #field_results1step8separ2').val(result[1]);
  $('.step8resultstest #field_results1step8separ3').val(result[2]);
  $('.step8resultstest #field_results1step8separ4').val(result[2]);
}
/* ONCLICK BUTTON FORM NEXT 8 */

/* ONCLICK BUTTON FORM NEXT 9 */
function nextForm9() {
  $('#contentCustomPageAACSection9 input[type="checkbox"].checkboxform1step9').on('change', function() {

	$('#contentCustomPageAACSection9 input[type="checkbox"].checkboxform1step9').on('change', function() {
	  $('#contentCustomPageAACSection9 input[type="checkbox"].checkboxform1step9').not(this).prop('checked', false);
	});
	
	var fields1 = '';
	$('#contentCustomPageAACSection9 input[type="checkbox"].checkboxform1step9').each(function() {
	  if (this.checked) {
		fields1 += $(this).val() + ' ';
	  }
	});
	$('.step9resultstest #field_results1step9').val($.trim(fields1))
  });
  
  var checkBox = document.getElementById("checkboxform1step9");
  var text = document.getElementById("finalform");
  if (($('#checkboxform1step9:checked').length)) {
	text.disabled = false;
  } else {
	text.disabled = true;
  }
}
/* ONCLICK BUTTON FORM NEXT 9 */

/* CLICK NEXT TO FORM 1 */
document.getElementById("continueForm").onclick = function() {
  continueForm();
}

function continueForm() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("active");
  document.getElementById("contentCustomPageAACSection1").classList.remove("noactive");
  
  document.getElementById("contentCustomPageAACSection2").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK NEXT TO FORM 1 */

/* CLICK NEXT TO FORM 2 */
document.getElementById("nextForm1").onclick = function() {
  continueForm1();
}

function continueForm1() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.add("active");
  document.getElementById("contentCustomPageAACSection2").classList.remove("noactive");
  
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK NEXT TO FORM 2 */

/* CLICK NEXT TO FORM 3 */
document.getElementById("nextForm2").onclick = function() {
  continueForm2();
}

function continueForm2() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.add("active");
  document.getElementById("contentCustomPageAACSection3").classList.remove("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");

  /* VALUES */
  let field_results1step2 = document.getElementById("field_results1step2").value;
  let field_results2step2 = document.getElementById("field_results2step2").value;
  let field_results1step3 = document.getElementById("field_results1step3").value;
  let field_results2step3 = document.getElementById("field_results2step3").value;
  let field_results1step4 = document.getElementById("field_results1step4").value;
  let field_results2step4 = document.getElementById("field_results2step4").value;
  let field_results3step4 = document.getElementById("field_results3step4").value;
  let field_results1step5 = document.getElementById("field_results1step5").value;
  let field_results2step5 = document.getElementById("field_results2step5").value;
  let field_results3step5 = document.getElementById("field_results3step5").value;
  let field_results1step6 = document.getElementById("field_results1step6").value;
  let field_results2step6 = document.getElementById("field_results2step6").value;
  let field_results1step8separ1 = document.getElementById("field_results1step8separ1").value;
  let field_results1step8separ2 = document.getElementById("field_results1step8separ2").value;
  let field_results1step8separ3 = document.getElementById("field_results1step8separ3").value;
  /* VALUES */

  if ((field_results1step2 == "C")) 
  {
	$("#field_resultscurcuscore1").val("1");
  }
  else 
  {
	$("#field_resultscurcuscore1").val("0");
  }

  if ((field_results1step2 == "B") || (field_results1step2 == "C")) 
  {
	$("#field_resultsklamascore1").val("1");
  }
  else 
  {
	$("#field_resultsklamascore1").val("0");
  }

  if ((field_results1step2 == "D")) 
  {
	$("#field_resultsthevertscore1").val("1");
  }
  else 
  {
	$("#field_resultsthevertscore1").val("0");
  }

  if ((field_results2step2 == "B") || (field_results2step2 == "C")) 
  {
	$("#field_resultsthevertscore2").val("1");
  }
  else 
  {
	$("#field_resultsthevertscore2").val("0");
  }
}
/* CLICK NEXT TO FORM 3 */

/* CLICK NEXT TO FORM 4 */
document.getElementById("nextForm3").onclick = function() {
  continueForm3();
}

function continueForm3() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.add("active");
  document.getElementById("contentCustomPageAACSection4").classList.remove("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");

  /* VALUES */
  let field_results1step2 = document.getElementById("field_results1step2").value;
  let field_results2step2 = document.getElementById("field_results2step2").value;
  let field_results1step3 = document.getElementById("field_results1step3").value;
  let field_results2step3 = document.getElementById("field_results2step3").value;
  let field_results1step4 = document.getElementById("field_results1step4").value;
  let field_results2step4 = document.getElementById("field_results2step4").value;
  let field_results3step4 = document.getElementById("field_results3step4").value;
  let field_results1step5 = document.getElementById("field_results1step5").value;
  let field_results2step5 = document.getElementById("field_results2step5").value;
  let field_results3step5 = document.getElementById("field_results3step5").value;
  let field_results1step6 = document.getElementById("field_results1step6").value;
  let field_results2step6 = document.getElementById("field_results2step6").value;
  let field_results1step8separ1 = document.getElementById("field_results1step8separ1").value;
  let field_results1step8separ2 = document.getElementById("field_results1step8separ2").value;
  let field_results1step8separ3 = document.getElementById("field_results1step8separ3").value;
  /* VALUES */

  if ((field_results1step3 == "B") || (field_results1step3 == "C") || (field_results1step3 == "D")) 
  {
	$("#field_resultsgravioscore1").val("1");
  }
  else 
  {
	$("#field_resultsgravioscore1").val("0");
  }

  if ((field_results2step3 == "B") || (field_results2step3 == "C")) 
  {
	$("#field_resultsklamascore2").val("1");
  }
  else 
  {
	$("#field_resultsklamascore2").val("0");
  }
}
/* CLICK NEXT TO FORM 4 */

/* CLICK NEXT TO FORM 5 */
document.getElementById("nextForm4").onclick = function() {
  continueForm4();
}

function continueForm4() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.add("active");
  document.getElementById("contentCustomPageAACSection5").classList.remove("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");

  /* VALUES */
  let field_results1step2 = document.getElementById("field_results1step2").value;
  let field_results2step2 = document.getElementById("field_results2step2").value;
  let field_results1step3 = document.getElementById("field_results1step3").value;
  let field_results2step3 = document.getElementById("field_results2step3").value;
  let field_results1step4 = document.getElementById("field_results1step4").value;
  let field_results2step4 = document.getElementById("field_results2step4").value;
  let field_results3step4 = document.getElementById("field_results3step4").value;
  let field_results1step5 = document.getElementById("field_results1step5").value;
  let field_results2step5 = document.getElementById("field_results2step5").value;
  let field_results3step5 = document.getElementById("field_results3step5").value;
  let field_results1step6 = document.getElementById("field_results1step6").value;
  let field_results2step6 = document.getElementById("field_results2step6").value;
  let field_results1step8separ1 = document.getElementById("field_results1step8separ1").value;
  let field_results1step8separ2 = document.getElementById("field_results1step8separ2").value;
  let field_results1step8separ3 = document.getElementById("field_results1step8separ3").value;
  /* VALUES */

  if ((field_results1step4 == "F")) 
  {
	$("#field_resultsastascore1").val("1");
	$("#field_resultsgrenascore1").val("1");
  }
  else 
  {
	$("#field_resultsastascore1").val("0");
	$("#field_resultsgrenascore1").val("0");
  }

  if ((field_results1step4 == "C") || (field_results1step4 == "D") || (field_results1step4 == "E")) 
  {
	$("#field_resultsklamascore3").val("1");
  }
  else 
  {
	$("#field_resultsklamascore3").val("0");
  }
  
  if ((field_results2step4 == "C")) 
  {
	$("#field_resultsastascore2").val("1");
  }
  else 
  {
	$("#field_resultsastascore2").val("0");
  }

  if ((field_results2step4 == "D") || (field_results2step4 == "E")) 
  {
	$("#field_resultscurcuscore2").val("1");
  }
  else 
  {
	$("#field_resultscurcuscore2").val("0");
  }

  if ((field_results3step4 == "B")) 
  {
	$("#field_resultsastascore3").val("1");
  }
  else 
  {
	$("#field_resultsastascore3").val("0");
  }

  if ((field_results3step4 == "C")) 
  {
	$("#field_resultscurcuscore3").val("1");
  }
  else 
  {
	$("#field_resultscurcuscore3").val("0");
  }
}
/* CLICK NEXT TO FORM 5 */

/* CLICK NEXT TO FORM 6 */
document.getElementById("nextForm5").onclick = function() {
  continueForm5();
}

function continueForm5() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.add("active");
  document.getElementById("contentCustomPageAACSection6").classList.remove("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");

  /* VALUES */
  let field_results1step2 = document.getElementById("field_results1step2").value;
  let field_results2step2 = document.getElementById("field_results2step2").value;
  let field_results1step3 = document.getElementById("field_results1step3").value;
  let field_results2step3 = document.getElementById("field_results2step3").value;
  let field_results1step4 = document.getElementById("field_results1step4").value;
  let field_results2step4 = document.getElementById("field_results2step4").value;
  let field_results3step4 = document.getElementById("field_results3step4").value;
  let field_results1step5 = document.getElementById("field_results1step5").value;
  let field_results2step5 = document.getElementById("field_results2step5").value;
  let field_results3step5 = document.getElementById("field_results3step5").value;
  let field_results1step6 = document.getElementById("field_results1step6").value;
  let field_results2step6 = document.getElementById("field_results2step6").value;
  let field_results1step8separ1 = document.getElementById("field_results1step8separ1").value;
  let field_results1step8separ2 = document.getElementById("field_results1step8separ2").value;
  let field_results1step8separ3 = document.getElementById("field_results1step8separ3").value;
  /* VALUES */

  if ((field_results1step5 == "B")) 
  {
	$("#field_resultsastascore4").val("1");
  }
  else 
  {
	$("#field_resultsastascore4").val("0");
  }
}
/* CLICK NEXT TO FORM 6 */

/* CLICK NEXT TO FORM 7 */
document.getElementById("nextForm6").onclick = function() {
  continueForm6();
}

function continueForm6() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.add("active");
  document.getElementById("contentCustomPageAACSection7").classList.remove("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK NEXT TO FORM 7 */

/* CLICK NEXT TO FORM 8 */
document.getElementById("nextForm7").onclick = function() {
  continueForm7();
}

function continueForm7() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.add("active");
  document.getElementById("contentCustomPageAACSection8").classList.remove("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK NEXT TO FORM 8 */

/* CLICK NEXT TO FORM 9 */
document.getElementById("nextForm8").onclick = function() {
  continueForm8();
}

function continueForm8() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.add("active");
  document.getElementById("contentCustomPageAACSection9").classList.remove("noactive");

  /* VALUES */
  let field_results1step2 = document.getElementById("field_results1step2").value;
  let field_results2step2 = document.getElementById("field_results2step2").value;
  let field_results1step3 = document.getElementById("field_results1step3").value;
  let field_results2step3 = document.getElementById("field_results2step3").value;
  let field_results1step4 = document.getElementById("field_results1step4").value;
  let field_results2step4 = document.getElementById("field_results2step4").value;
  let field_results3step4 = document.getElementById("field_results3step4").value;
  let field_results1step5 = document.getElementById("field_results1step5").value;
  let field_results2step5 = document.getElementById("field_results2step5").value;
  let field_results3step5 = document.getElementById("field_results3step5").value;
  let field_results1step6 = document.getElementById("field_results1step6").value;
  let field_results2step6 = document.getElementById("field_results2step6").value;
  let field_results1step8separ1 = document.getElementById("field_results1step8separ1").value;
  let field_results1step8separ2 = document.getElementById("field_results1step8separ2").value;
  let field_results1step8separ3 = document.getElementById("field_results1step8separ3").value;
  /* VALUES */

  if ((field_results1step8separ1 == "A") || (field_results1step8separ2 == "A") || (field_results1step8separ3 == "A")) 
  {
	$("#field_resultscurcuscore4").val("1");
	$("#field_resultsklamascore4").val("1");
	$("#field_resultsgrenascore2").val("1");
  }
  



  

  if ((field_results1step8separ1 == "B") || (field_results1step8separ2 == "B") || (field_results1step8separ3 == "B")) 
  {
	$("#field_resultsklamascore4").val("1");
	$("#field_resultsthevertscore3").val("1");
  }
  



  

  if ((field_results1step8separ1 == "C") || (field_results1step8separ2 == "C") || (field_results1step8separ3 == "C")) 
  {
	$("#field_resultsklamascore4").val("1");
  }
  




  if ((field_results1step8separ1 == "D") || (field_results1step8separ2 == "D") || (field_results1step8separ3 == "D")) 
  {
	$("#field_resultsklamascore4").val("1");
	$("#field_resultsgravioscore2").val("1");
  }
  




  if ((field_results1step8separ1 == "E") || (field_results1step8separ2 == "E") || (field_results1step8separ3 == "E")) 
  {
	$("#field_resultsklamascore4").val("1");
	$("#field_resultsgravioscore2").val("1");
	$("#field_resultsthevertscore3").val("1");
  }
  




  if ((field_results1step8separ1 == "F") || (field_results1step8separ2 == "F") || (field_results1step8separ3 == "F")) 
  {
	$("#field_resultsklamascore4").val("1");
  }
  



  if ((field_results1step8separ1 == "G") || (field_results1step8separ2 == "G") || (field_results1step8separ3 == "G")) 
  {
	$("#field_resultscurcuscore4").val("1");
  }
  




  if ((field_results1step8separ1 == "H") || (field_results1step8separ2 == "H") || (field_results1step8separ3 == "H")) 
  {
	$("#field_resultsastascore5").val("1");
	$("#field_resultsklamascore4").val("1");
	$("#field_resultsgrenascore2").val("1");
  }
  




  if ((field_results1step8separ1 == "I") || (field_results1step8separ2 == "I") || (field_results1step8separ3 == "I")) 
  {
	$("#field_resultsklamascore4").val("1");
	$("#field_resultsgravioscore2").val("1");
	$("#field_resultsthevertscore3").val("1");
  }
  



  if ((field_results1step8separ1 == "J") || (field_results1step8separ2 == "J") || (field_results1step8separ3 == "J")) 
  {
	$("#field_resultscurcuscore4").val("1");
	$("#field_resultsgrenascore2").val("1");
	$("#field_resultsthevertscore3").val("1");
  }
  




  if ((field_results1step8separ1 == "K") || (field_results1step8separ2 == "K") || (field_results1step8separ3 == "K")) 
  {
	$("#field_resultscurcuscore4").val("1");
	$("#field_resultsgravioscore2").val("1");
  }
  



  if ((field_results1step8separ1 == "L") || (field_results1step8separ2 == "L") || (field_results1step8separ3 == "L")) 
  {
	$("#field_resultsastascore5").val("1");
	$("#field_resultsgrenascore2").val("1");
  }
  




  if ((field_results1step8separ1 == "M") || (field_results1step8separ2 == "M") || (field_results1step8separ3 == "M")) 
  {
	$("#field_resultsgravioscore2").val("1");
  }
  




  if ((field_results1step8separ1 == "N") || (field_results1step8separ2 == "N") || (field_results1step8separ3 == "N")) 
  {
	$("#field_resultsklamascore4").val("1");
	$("#field_resultsgrenascore2").val("1");
  }
  



  if ((field_results1step8separ1 == "P") || (field_results1step8separ2 == "P") || (field_results1step8separ3 == "P")) 
  {
	$("#field_resultsastascore5").val("1");
  }

  let field_resultsastascore1 = document.getElementById("field_resultsastascore1").value;
  let field_resultsastascore2 = document.getElementById("field_resultsastascore2").value;
  let field_resultsastascore3 = document.getElementById("field_resultsastascore3").value;
  let field_resultsastascore4 = document.getElementById("field_resultsastascore4").value;
  let field_resultsastascore5 = document.getElementById("field_resultsastascore5").value;

  let field_resultscurcuscore1 = document.getElementById("field_resultscurcuscore1").value;
  let field_resultscurcuscore2 = document.getElementById("field_resultscurcuscore2").value;
  let field_resultscurcuscore3 = document.getElementById("field_resultscurcuscore3").value;
  let field_resultscurcuscore4 = document.getElementById("field_resultscurcuscore4").value;
  let field_resultscurcuscore5 = document.getElementById("field_resultscurcuscore5").value;

  let field_resultsklamascore1 = document.getElementById("field_resultsklamascore1").value;
  let field_resultsklamascore2 = document.getElementById("field_resultsklamascore2").value;
  let field_resultsklamascore3 = document.getElementById("field_resultsklamascore3").value;
  let field_resultsklamascore4 = document.getElementById("field_resultsklamascore4").value;
  let field_resultsklamascore5 = document.getElementById("field_resultsklamascore5").value;

  let field_resultsgravioscore1 = document.getElementById("field_resultsgravioscore1").value;
  let field_resultsgravioscore2 = document.getElementById("field_resultsgravioscore2").value;
  let field_resultsgravioscore3 = document.getElementById("field_resultsgravioscore3").value;
  let field_resultsgravioscore4 = document.getElementById("field_resultsgravioscore4").value;
  let field_resultsgravioscore5 = document.getElementById("field_resultsgravioscore5").value;

  let field_resultsgrenascore1 = document.getElementById("field_resultsgrenascore1").value;
  let field_resultsgrenascore2 = document.getElementById("field_resultsgrenascore2").value;
  let field_resultsgrenascore3 = document.getElementById("field_resultsgrenascore3").value;
  let field_resultsgrenascore4 = document.getElementById("field_resultsgrenascore4").value;
  let field_resultsgrenascore5 = document.getElementById("field_resultsgrenascore5").value;

  let field_resultsthevertscore1 = document.getElementById("field_resultsthevertscore1").value;
  let field_resultsthevertscore2 = document.getElementById("field_resultsthevertscore2").value;
  let field_resultsthevertscore3 = document.getElementById("field_resultsthevertscore3").value;
  let field_resultsthevertscore4 = document.getElementById("field_resultsthevertscore4").value;
  let field_resultsthevertscore5 = document.getElementById("field_resultsthevertscore5").value;

  var total1 = (field_resultsastascore1*1) + (field_resultsastascore2*1) + (field_resultsastascore3*1) + (field_resultsastascore4*1) + (field_resultsastascore5*1);
  $("#field_resultsastascore").val(total1);

  var total2 = (field_resultscurcuscore1*1) + (field_resultscurcuscore2*1) + (field_resultscurcuscore3*1) + (field_resultscurcuscore4*1) + (field_resultscurcuscore5*1);
  $("#field_resultscurcuscore").val(total2);

  var total3 = (field_resultsklamascore1*1) + (field_resultsklamascore2*1) + (field_resultsklamascore3*1) + (field_resultsklamascore4*1) + (field_resultsklamascore5*1);
  $("#field_resultsklamascore").val(total3);

  var total4 = (field_resultsgravioscore1*1) + (field_resultsgravioscore2*1) + (field_resultsgravioscore3*1) + (field_resultsgravioscore4*1) + (field_resultsgravioscore5*1);
  $("#field_resultsgravioscore").val(total4);

  var total5 = (field_resultsgrenascore1*1) + (field_resultsgrenascore2*1) + (field_resultsgrenascore3*1) + (field_resultsgrenascore4*1) + (field_resultsgrenascore5*1);
  $("#field_resultsgrenascore").val(total5);

  var total6 = (field_resultsthevertscore1*1) + (field_resultsthevertscore2*1) + (field_resultsthevertscore3*1) + (field_resultsthevertscore4*1) + (field_resultsthevertscore5*1);
  $("#field_resultsthevertscore").val(total6);
  
  
}
/* CLICK NEXT TO FORM 9 */

/* CLICK NEXT TO FORM 9 */
document.getElementById("nextForm9").onclick = function() {
  document.getElementById("loader-container").classList.add("active");
  document.getElementById("load").classList.add("active");
  setTimeout(function(){
	document.getElementById("loader-container").classList.remove("active");
	document.getElementById("load").classList.remove("active");
  }, 5000);
  document.getElementById("contentresultproducts").classList.add("active");
  continueForm9();
}

function continueForm9() {
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK NEXT TO FORM 9 */

/* CLICK PREV TO FORM 1 */
document.getElementById("prevForm2").onclick = function() {
  prevForm2();
}

function prevForm2() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.remove("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.add("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK PREV TO FORM 1 */

/* CLICK PREV TO FORM 2 */
document.getElementById("prevForm3").onclick = function() {
  prevForm3();
}

function prevForm3() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.remove("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.add("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK PREV TO FORM 2 */

/* CLICK PREV TO FORM 3 */
document.getElementById("prevForm4").onclick = function() {
  prevForm4();
}

function prevForm4() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.remove("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.add("active");
  document.getElementById("contentCustomPageAACSection3").classList.remove("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK PREV TO FORM 3 */

/* CLICK PREV TO FORM 4 */
document.getElementById("prevForm5").onclick = function() {
  prevForm5();
}

function prevForm5() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.remove("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.add("active");
  document.getElementById("contentCustomPageAACSection4").classList.remove("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK PREV TO FORM 4 */

/* CLICK PREV TO FORM 5 */
document.getElementById("prevForm6").onclick = function() {
  prevForm6();
}

function prevForm6() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.remove("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.add("active");
  document.getElementById("contentCustomPageAACSection5").classList.remove("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK PREV TO FORM 5 */

/* CLICK PREV TO FORM 6 */
document.getElementById("prevForm7").onclick = function() {
  prevForm7();
}

function prevForm7() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.remove("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.add("active");
  document.getElementById("contentCustomPageAACSection6").classList.remove("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK PREV TO FORM 6 */

/* CLICK PREV TO FORM 7 */
document.getElementById("prevForm8").onclick = function() {
  prevForm8();
}

function prevForm8() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.remove("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.add("active");
  document.getElementById("contentCustomPageAACSection7").classList.remove("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK PREV TO FORM 7 */

/* CLICK PREV TO FORM 8 */
document.getElementById("prevForm9").onclick = function() {
  prevForm9();
}

function prevForm9() {
  window.scroll({
	top: 80,
	behavior: 'smooth'
  });
  
  document.getElementById("contentCustomPageAACSection0").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection2").classList.remove("noactive");
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.add("active");
  document.getElementById("contentCustomPageAACSection8").classList.remove("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
}
/* CLICK PREV TO FORM 8 */
  
/* CLICK RETURN BEGIN FORM */
function returnFormBegin() {
  document.getElementById("loader-container").classList.add("active");
  document.getElementById("load").classList.add("active");
  setTimeout(function(){
	document.getElementById("loader-container").classList.remove("active");
	document.getElementById("load").classList.remove("active");
  }, 5000);
  
  document.getElementById("contentCustomPageAACSection0").classList.remove("noactive");
  document.getElementById("contentCustomPageAACSection0").classList.add("active");
  
  document.getElementById("contentCustomPageAACSection1").classList.remove("active");
  document.getElementById("contentCustomPageAACSection1").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection2").classList.remove("active");
  document.getElementById("contentCustomPageAACSection2").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection3").classList.remove("active");
  document.getElementById("contentCustomPageAACSection3").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection4").classList.remove("active");
  document.getElementById("contentCustomPageAACSection4").classList.add("noactive");
  
  document.getElementById("contentCustomPageAACSection5").classList.remove("active");
  document.getElementById("contentCustomPageAACSection5").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection6").classList.remove("active");
  document.getElementById("contentCustomPageAACSection6").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection7").classList.remove("active");
  document.getElementById("contentCustomPageAACSection7").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection8").classList.remove("active");
  document.getElementById("contentCustomPageAACSection8").classList.add("noactive");

  document.getElementById("contentCustomPageAACSection9").classList.remove("active");
  document.getElementById("contentCustomPageAACSection9").classList.add("noactive");
  
  window.location.href = "https://green-ethnies.com/pages/aide-au-choix/";
}
/* CLICK RETURN BEGIN FORM */

/* FINISH FORM GET RESULTS */
document.getElementById("finalform").onclick = function() {
  finalform();
}
/* FINISH FORM GET RESULTS */

function finalform() {

  /* VALUES */
  let field_results1step2 = document.getElementById("field_results1step2").value;
  let field_results2step2 = document.getElementById("field_results2step2").value;
  let field_results1step3 = document.getElementById("field_results1step3").value;
  let field_results2step3 = document.getElementById("field_results2step3").value;
  let field_results1step4 = document.getElementById("field_results1step4").value;
  let field_results2step4 = document.getElementById("field_results2step4").value;
  let field_results3step4 = document.getElementById("field_results3step4").value;
  let field_results1step5 = document.getElementById("field_results1step5").value;
  let field_results2step5 = document.getElementById("field_results2step5").value;
  let field_results3step5 = document.getElementById("field_results3step5").value;
  let field_results1step6 = document.getElementById("field_results1step6").value;
  let field_results2step6 = document.getElementById("field_results2step6").value;
  let field_results1step8separ1 = document.getElementById("field_results1step8separ1").value;
  let field_results1step8separ2 = document.getElementById("field_results1step8separ2").value;
  let field_results1step8separ3 = document.getElementById("field_results1step8separ3").value;


  let field_resultsastascore = document.getElementById("field_resultsastascore").value;
  let field_resultscurcuscore = document.getElementById("field_resultscurcuscore").value;
  let field_resultsklamascore = document.getElementById("field_resultsklamascore").value;
  let field_resultsgravioscore = document.getElementById("field_resultsgravioscore").value;
  let field_resultsgrenascore = document.getElementById("field_resultsgrenascore").value;
  let field_resultsthevertscore = document.getElementById("field_resultsthevertscore").value;
  /* VALUES */

  /* ORDRE PRIO PRODUITS */
  //klamath (4) / grenade (2) / curcumine (4) / astaxanthine (5) / graviola (2) / the-vert (3)
  /* ORDRE PRIO PRODUITS */

  if ((field_resultsklamascore == "4") && (field_resultsgrenascore == "2")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product16").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "4") && (field_resultsgrenascore == "1") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product10").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "4") && (field_resultsgrenascore == "1")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product16").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "3") && (field_resultsgrenascore == "2")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product16").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "3") && (field_resultsgrenascore == "1") && (field_resultsgravioscore < "2") && (field_resultsastascore < "5") && (field_resultsthevertscore < "3") && (field_resultscurcuscore < "4")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product16").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
	
  else if ((field_resultsklamascore == "4") && (field_resultscurcuscore == "4")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product3").classList.add("active");
	document.getElementById("product13").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "4") && (field_resultscurcuscore == "3")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product3").classList.add("active");
	document.getElementById("product13").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "3") && (field_resultscurcuscore == "4")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product3").classList.add("active");
	document.getElementById("product13").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "3") && (field_resultscurcuscore == "3") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product10").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "3") && (field_resultscurcuscore == "3")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product3").classList.add("active");
	document.getElementById("product13").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
	
  else if ((field_resultsklamascore == "4") && (field_resultsastascore == "5")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product3").classList.add("active");
	document.getElementById("product19").classList.add("active");

	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "4") && (field_resultsastascore == "4")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product3").classList.add("active");
	document.getElementById("product19").classList.add("active");

	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "3") && (field_resultsastascore == "5")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product3").classList.add("active");
	document.getElementById("product19").classList.add("active");

	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "3") && (field_resultsastascore == "4")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product3").classList.add("active");
	document.getElementById("product19").classList.add("active");

	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }

  else if ((field_resultsklamascore == "4") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product12").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "4") && (field_resultsgravioscore == "1")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product12").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "3") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product12").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "3") && (field_resultsgravioscore == "1")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product12").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }

  else if ((field_resultsklamascore == "4") && (field_resultsthevertscore == "3")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product20").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "4") && (field_resultsthevertscore == "2")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product20").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "3") && (field_resultsthevertscore == "3")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product20").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "3") && (field_resultsthevertscore == "2")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product20").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }


	
	
  else if ((field_resultsgrenascore == "2") && (field_resultscurcuscore == "4")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product14").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "2") && (field_resultscurcuscore == "3")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product14").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "1") && (field_resultscurcuscore == "4") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product4").classList.add("active");
	document.getElementById("product2").classList.add("active");
	document.getElementById("product18").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "1") && (field_resultscurcuscore == "4")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product14").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "1") && (field_resultscurcuscore == "3")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product14").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
	
  else if ((field_resultsgrenascore == "2") && (field_resultsastascore == "5")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product15").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "2") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product4").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product11").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "2") && (field_resultsastascore == "4")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product15").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "1") && (field_resultsastascore == "5")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product15").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "1") && (field_resultsastascore == "4")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product15").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }

  else if ((field_resultsgrenascore == "2") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product4").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product11").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "2") && (field_resultsgravioscore == "1")) 
  {
	document.getElementById("product4").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product11").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "1") && (field_resultsthevertscore == "3") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product4").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product25").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "1") && (field_resultsthevertscore == "3")) 
  {
	document.getElementById("product5").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product17").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore == "2") && (field_resultsgrenascore == "1") && (field_resultsgravioscore == "2") && (field_resultsastascore < "5") && (field_resultsthevertscore < "3") && (field_resultscurcuscore < "4")) 
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product12").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore < "4") && (field_resultsgrenascore == "1") && (field_resultsgravioscore == "2") && (field_resultsastascore < "5") && (field_resultsthevertscore < "3") && (field_resultscurcuscore < "4")) 
  {
	document.getElementById("product4").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product11").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "1") && (field_resultsgravioscore == "1")) 
  {
	document.getElementById("product4").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product11").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }

  else if ((field_resultsgrenascore == "2") && (field_resultsthevertscore == "2") && (field_resultsastascore >= "3")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product15").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "2") && (field_resultsthevertscore == "3")) 
  {
	document.getElementById("product5").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product17").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "2") && (field_resultsthevertscore == "2")) 
  {
	document.getElementById("product5").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product17").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsklamascore < "4") && (field_resultsgrenascore == "1") && (field_resultsgravioscore == "2") && (field_resultsastascore < "5") && (field_resultsthevertscore < "3") && (field_resultscurcuscore < "4")) 
  {
	document.getElementById("product5").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product17").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsgrenascore == "1") && (field_resultsthevertscore == "2")) 
  {
	document.getElementById("product5").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product17").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }




	
  
	
  else if ((field_resultscurcuscore == "4") && (field_resultsastascore == "5")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product2").classList.add("active");
	document.getElementById("product21").classList.add("active");

	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultscurcuscore == "4") && (field_resultsastascore == "4")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product2").classList.add("active");
	document.getElementById("product21").classList.add("active");

	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultscurcuscore == "3") && (field_resultsastascore == "5")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product2").classList.add("active");
	document.getElementById("product21").classList.add("active");

	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultscurcuscore == "3") && (field_resultsastascore == "4")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product2").classList.add("active");
	document.getElementById("product21").classList.add("active");

	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }

  else if ((field_resultscurcuscore == "4") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product18").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultscurcuscore == "4") && (field_resultsgravioscore == "1")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product18").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultscurcuscore == "3") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product18").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultscurcuscore == "3") && (field_resultsgravioscore == "1")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product18").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }

  else if ((field_resultscurcuscore == "4") && (field_resultsthevertscore == "3")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product22").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultscurcuscore == "4") && (field_resultsthevertscore == "2")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product22").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultscurcuscore == "3") && (field_resultsthevertscore == "3")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product22").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultscurcuscore == "3") && (field_resultsthevertscore == "2")) 
  {
	document.getElementById("product2").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product22").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }








  else if ((field_resultsastascore == "5") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product23").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsastascore == "5") && (field_resultsgravioscore == "1")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product23").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsastascore == "4") && (field_resultsgravioscore == "2")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product23").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsastascore == "4") && (field_resultsgravioscore == "1")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product4").classList.add("active");
	document.getElementById("product23").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }

  else if ((field_resultsastascore == "5") && (field_resultsthevertscore == "3")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product24").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsastascore == "5") && (field_resultsthevertscore == "2")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product24").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsastascore == "4") && (field_resultsthevertscore == "3")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product24").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }
  else if ((field_resultsastascore == "4") && (field_resultsthevertscore == "2")) 
  {
	document.getElementById("product1").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product24").classList.add("active");

	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }







  else if ((field_resultsgravioscore == "2") && (field_resultsthevertscore == "3")) 
  {
	document.getElementById("product4").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product25").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
  }
  else if ((field_resultsgravioscore == "2") && (field_resultsthevertscore == "2")) 
  {
	document.getElementById("product4").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product25").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
  }
  else if ((field_resultsgravioscore == "1") && (field_resultsthevertscore == "3")) 
  {
	document.getElementById("product4").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product25").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
  }
  else if ((field_resultsgravioscore == "1") && (field_resultsthevertscore == "2")) 
  {
	document.getElementById("product4").classList.add("active");
	document.getElementById("product6").classList.add("active");
	document.getElementById("product25").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product3").classList.remove("active");
	document.getElementById("product5").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product12").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product16").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
  }

  else
  {
	document.getElementById("product3").classList.add("active");
	document.getElementById("product5").classList.add("active");
	document.getElementById("product16").classList.add("active");

	document.getElementById("product1").classList.remove("active");
	document.getElementById("product2").classList.remove("active");
	document.getElementById("product4").classList.remove("active");
	document.getElementById("product6").classList.remove("active");
	document.getElementById("product7").classList.remove("active");
	document.getElementById("product8").classList.remove("active");
	document.getElementById("product9").classList.remove("active");
	document.getElementById("product10").classList.remove("active");
	document.getElementById("product11").classList.remove("active");
	document.getElementById("product13").classList.remove("active");
	document.getElementById("product14").classList.remove("active");
	document.getElementById("product15").classList.remove("active");
	document.getElementById("product17").classList.remove("active");
	document.getElementById("product18").classList.remove("active");
	document.getElementById("product19").classList.remove("active");
	document.getElementById("product20").classList.remove("active");
	document.getElementById("product21").classList.remove("active");
	document.getElementById("product22").classList.remove("active");
	document.getElementById("product23").classList.remove("active");
	document.getElementById("product24").classList.remove("active");
	document.getElementById("product25").classList.remove("active");
  }





  

  document.getElementById("contentresultproducts").classList.add("active");

  $("#nextForm9").trigger("click");

  $("body").addClass("showproducts");

  $("#finalFormMess").addClass("active");
	
  
}